// extracted by mini-css-extract-plugin
export var callCard = "_pr-0";
export var callMessageButton = "_pr-1";
export var helpIcon = "_pr-3";
export var helpIconContainer = "_pr-4";
export var verticalDivider = "_pr-2";